import React, { useState, useRef, useEffect } from "react";
import Barcode from "react-barcode";
import { toPng } from "html-to-image";
import jsPDF from "jspdf";
import "./barcode reader.css";

function BarcodeGenerator() {
  const [barcodeValue, setBarcodeValue] = useState("");
  const [productCode, setProductCode] = useState("");
  const [price, setPrice] = useState("");
  const barcodeRef = useRef(null);
  const [barcodeWidth, setBarcodeWidth] = useState(1.8);

  useEffect(() => {
    if (barcodeValue) {
      const length = barcodeValue.length;
      let newWidth;
      
      if (length <= 8) newWidth = 2.2;
      else if (length <= 12) newWidth = 1.8;
      else if (length <= 16) newWidth = 1.4;
      else newWidth = 1.0;
      
      setBarcodeWidth(newWidth);
    }
  }, [barcodeValue]);

  const handleDownload = async () => {
    if (!barcodeRef.current) return;

    try {
      // Get the actual element
      const element = barcodeRef.current;
      
      // Capture with proper settings
      const dataUrl = await toPng(element, {
        backgroundColor: '#FFFFFF',
        pixelRatio: 3,
        quality: 1,
        width: 900,
        height: 150
      });

      const pdf = new jsPDF({
        unit: 'mm',
        format: [90, 15],
        orientation: 'landscape'
      });

      // Add image
      pdf.addImage(
        dataUrl,
        'PNG',
        0, 0,
        90, 15
      );

      pdf.save(`${barcodeValue || "barcode"}.pdf`);

    } catch (err) {
      console.error("Error generating PDF:", err);
      alert("Error generating PDF. Please try again.");
    }
  };

  return (
    <div className="barcode-app">
      <div className="input-section">
        <h1 className="app-title">Barcode Label Generator</h1>

        <div className="input-group">
          <label>Barcode Value *</label>
          <input
            type="text"
            value={barcodeValue}
            onChange={(e) => setBarcodeValue(e.target.value)}
            placeholder="e.g., C04818001"
            maxLength={20}
          />
        </div>

        <div className="input-group">
          <label>Product Code</label>
          <input
            type="text"
            value={productCode}
            onChange={(e) => setProductCode(e.target.value)}
            placeholder="e.g., CHP-630 52 17 142"
          />
        </div>

        <div className="input-group">
          <label>Price</label>
          <input
            type="text"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            placeholder="e.g., 9500/-"
          />
        </div>
      </div>

      {/* THE LABEL - Using fixed pixel dimensions */}
      <div 
        ref={barcodeRef}
        style={{
          width: '900px',
          height: '150px',
          display: 'flex',
          backgroundColor: 'white',
          border: '1px solid #ccc',
          padding: 0,
          margin: '20px 0',
          boxSizing: 'border-box',
          overflow: 'hidden',
          flexShrink: 0
        }}
      >
        {/* SECTION 1: BLANK - 30mm = 300px */}
        <div style={{
          width: '300px',
          height: '150px',
          backgroundColor: 'white',
          flexShrink: 0
        }}>
          {/* INTENTIONALLY EMPTY - NO PRINTING */}
        </div>

        {/* SECTION 2: BARCODE + PRODUCT CODE - 30mm = 300px */}
        <div style={{
          width: '300px',
          height: '150px',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white',
          flexShrink: 0,
          padding: '5px 0',
          boxSizing: 'border-box'
        }}>
          {/* Barcode on top */}
          <div style={{
            height: '90px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
          }}>
            {barcodeValue ? (
              <Barcode
                value={barcodeValue}
                format="CODE128"
                width={barcodeWidth}
                height={80}
                displayValue={false}
                background="transparent"
                margin={0}
                fontSize={0}
                lineColor="#000000"
              />
            ) : (
              <div style={{ fontSize: '12px', color: '#999' }}>No barcode</div>
            )}
          </div>
          
          {/* Product Code below barcode */}
    <div style={{
  height: '50px',
  display: 'flex',
  alignItems: 'flex-start', // Changed from 'center' to 'flex-start'
  justifyContent: 'center',
  borderTop: '1px solid #000',
  width: '100%',
  paddingTop: '4px' // Add this to push content up
}}>
  <p style={{
    margin: 0,
    fontSize: '18px',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#000',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    padding: '0 5px',
    width: '100%'
  }}>
    

              {productCode || barcodeValue || 'Product Code'}
            </p>
          </div>
        </div>

        {/* SECTION 3: PRODUCT CODE + PRICE - 30mm = 300px */}
        <div style={{
          width: '300px',
          height: '150px',
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'white',
          flexShrink: 0,
          padding: '5px 0',
          boxSizing: 'border-box'
        }}>
          {/* Product Code on top */}
          <div style={{
            height: '65px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderBottom: '1px solid #000',
            width: '100%'
          }}>
            <p style={{
              margin: 0,
              fontSize: '20px',
              fontWeight: 'bold',
              textAlign: 'center',
              color: '#000',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              padding: '0 5px',
              width: '100%'
            }}>
              {productCode || barcodeValue || 'Product Code'}
            </p>
          </div>
          
          {/* Price below */}
          <div style={{
            height: '75px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%'
          }}>
            <p style={{
              margin: 0,
              fontSize: '28px',
              fontWeight: 'bold',
              textAlign: 'center',
              color: '#000',
              letterSpacing: '0.5px'
            }}>
              {price || 'Price'}
            </p>
          </div>
        </div>
      </div>

      <button
        className="download-btn"
        onClick={handleDownload}
        disabled={!barcodeValue}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path
            d="M12 15V3M12 15L8 11M12 15L16 11M21 15V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V15"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        Download PDF
      </button>
    </div>
  );
}

export default BarcodeGenerator;